import { hasValue } from "@itk/typescript-utils";

type Name = {
  firstName?: string;
  middleName?: string;
  lastName?: string;
};

export const concatenateNames = <T extends Name>(names: T) => {
  return `${names.firstName ?? ""}${hasValue(names.middleName) ? ` ${names.middleName}` : ""} ${names.lastName ?? ""}`;
};

export function isOverflowing(element: HTMLAnchorElement | null) {
  if (!element) return false;
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
}
